// extracted by mini-css-extract-plugin
export var footer = "_rd-0";
export var inherit = "_rd-1";
export var input = "_rd-2";
export var modalContent = "_rd-3";
export var quillEditor = "_rd-4";
export var subtitle = "_rd-5";